const updateShipAidLogoSVG = () => {
  // Update SVG Inside ShipAid Widget
  const widgetGenerated = document.querySelector('shipaid-widget');
  
  if(widgetGenerated){
    const logoSVG = widgetGenerated.shadowRoot.querySelector('svg');
    if(logoSVG){
      logoSVG.setAttribute('style', 'filter: brightness(0) invert(0.7) !important')
    }
  }
}

const watchRebuyCartLoad = setInterval(function() {
    
    const country = window.Shopify?.country
    // Enable Widget only for UK
    if (country != "GB") {
      clearInterval(watchRebuyCartLoad);
      return;
    }
  
    const existingShipAidEle = document.querySelector("shipaid-widget");
    if (existingShipAidEle) {
      clearInterval(watchRebuyCartLoad);
      return;
    }

    // Create Shipaid element
    const customDiv1 = document.createElement('div');
    customDiv1.style.setProperty("margin-bottom", "-25px");
    
    let subtitleFont = '11px'
    // Adjusting font size for mobile
     if (window.innerWidth <= 768) {
       subtitleFont = '10px'
     }
    customDiv1.innerHTML= `<shipaid-widget disableRefresh currency=${window.Shopify?.currency?.active} style="--shipaid-text: #FFF; --shipaid-text-description: #595C5E;--shipaid-toggle-active: #00AEEF; --shipaid-prompt-actions-price-color: #4F4F4F; --shipaid-prompt-actions-button-color: #00AEEF; --shipaid-prompt-width: 100%; --shipaid-prompt-badge-border-radius: 0px; --shipaid-prompt-footer-button-size: 5px; --shipaid-font-xs: 8px; --shipaid-footer-badge-logo-height: 8px; --shipaid-prompt-footer-location: flex-end; --shipaid-prompt-product-actions-content: start; --shipaid-prompt-footer-topMargin: -8px; --shipaid-prompt-footer-display: none"><span slot="title">Order Protection</span><p slot="subtitle" style="font-size: ${subtitleFont}">Instant replacement if lost, stolen or damaged.</p></shipaid-widget>`

    // Get the DIV of Rebuy Cart and find the div for subtotal
    const targetDiv = document.getElementById('rebuy-cart')
    // Add widget div above checkout button
    if (targetDiv) {
      const children1 = targetDiv.children[0];
      if (children1) {
        const children2 = children1.children[2]
        if (children2) {
          const children3 = children2.children[2]
          if (children3) {
            children3.after(customDiv1)

            setTimeout(() => {updateShipAidLogoSVG()}, 2500)
          }
        }
        
      }
      
    }    
}, 3000);

document.addEventListener('shipaid-protection-status', () => {
  updateShipAidLogoSVG()
})

document.addEventListener('shipaid-loaded', () => {
  updateShipAidLogoSVG()
})

